<template>
  <div class="header-menu">
    <div class="header-navigation-item" :class="state.active === item.id ? 'header-navigation-item-active' : ''"
      v-for="item in state.menu" :key="item.id" @click="linkTo(item)" @mouseover="towMenuShow(item)">

      <a-dropdown v-if="item.id === 'about'" placement="bottom">
        <div @click.prevent>
          {{ item.name }}
        </div>
        <template #overlay>
          <a-menu>
            <a-menu-item key="0" @click="resourceJump('companyProfile')">
              <a>公司介绍</a>
            </a-menu-item>
            <a-menu-item key="1" @click="resourceJump('serviceNetwork')">
              <a>服务网络</a>
            </a-menu-item>
            <a-menu-item key="2" @click="resourceJump('cooperationMode')">
              <a>合作模式</a>
            </a-menu-item>
          </a-menu>
        </template>
      </a-dropdown>
      <div v-else>{{ item.name }}</div>
    </div>
    <div class="header-navigation-item-towMenu" v-if="state.towMenuShow" @mouseleave="removeTowMenuShow()">
      <div class="towMenu-container">
        <div v-for="item in state.towMenu" :key="item.id">
          <div class="towMenu-oneMenu" v-if="item.children && item.children.length > 0"> {{ item.name }} </div>
          <div v-for="(twoItem, index) in item.children" :key="twoItem.id" class="towMenu-towMenu">
            <span v-if="index <= 10" @click="linkToChild(twoItem)" class="towMenu-towMenu-item">
              {{ twoItem.name }}
            </span>
            <span v-if="index === 11" style="color: #1890ff; cursor: pointer" @click="linkToChild(item)">更多</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  defineComponent,
  onMounted,
  reactive,
  ref,
  watch,
  getCurrentInstance
} from 'vue'
import {
  useRouter,
} from 'vue-router'
import {
  NAV_CONFIG
} from "@/utils/PAGE-CONFIG.js"
import { getFilterList } from "@/api/index"
import emitter from '@/assets/js/eventBus';
export default defineComponent({
  name: 'Menu',
  components: {
  },
  props: {},
  setup (props) {
    const { ctx } = getCurrentInstance()
    const router = useRouter()
    let state = reactive({
      menu: NAV_CONFIG,
      active: 'home',
      towMenu: [],
      towMenuShow: false,
    })
    watch(() => router.currentRoute.value.name, (newValue, oldValue) => {
      state.active = newValue
    }, {
      immediate: true
    })

    watch(() => props.active, (newVal) => {
      state.active = newVal
    })

    const linkTo = (item) => {
      state.active = item.id
      if (item.id === 'about') {
        let path = '/about'
        let query = {}
        query.id = 'companyProfile'
        router.push({
          path: path,
          query: query
        })
      } else if (item.path && item.path !== '') {
        if (item.path == "/product") {
          emitter.emit("close-info-product")
        } else if (item.path == "/news") {
          emitter.emit("close-info-example")
        }
        router.push(item.path)
      } else {
        item.link && window.open(item.link)
      }
    }

    const linkToChild = (item) => {
      console.log(item);


      if (item.id === "MAPaaS") {
        window.open("https://platform.mapaas.com/home")
        return
      } else if (item.children && item.children.length > 0) {
        router.push({
          path: '/product',
          query: {
            groupId: item.rowId
          }
        })
      } else {
        router.push({
          path: '/product',
          query: {
            id: item.rowId
          }
        })
      }

    }

    const getData = async () => {
      let params = {
        page: 1,
        pageSize: 100,
        sortField: "number84ecee89",
        isAsc: false,
        worksheetId: "680f485b88d915058691f9de",
      }
      const res = await getFilterList(params)
      if (res.code === 200 && res.data && res.data.length > 0) {
        state.menu[1].children = res.data
        res.data.forEach(item => {
          item.name = item.input988275a1
          if (item.input988275a1 === "零代码产品") {
            if (item.associationFieldsb2d1b102) {
              let list = item.associationFieldsb2d1b102.sort(function (a, b) {
                return b.number68b2284b - a.number68b2284b;
              });
              item.children = list.map(val => {
                return {
                  id: val.input988275a1 === '畅图云' ? 'MAPaaS' : val.rowId,
                  name: val.input988275a1,
                  rowId: val.rowId
                }
              })
            }

          } else {
            if (item.associationFieldsb2d1b102) {
              let list = item.associationFieldsb2d1b102.sort(function (a, b) {
                return b.number68b2284b - a.number68b2284b;
              });
              item.children = list.map(val => {
                return {
                  id: val.rowId,
                  name: val.input988275a1,
                  rowId: val.rowId
                }
              })
            }
          }
        })

      }


    }
    const towMenuShow = (item) => {
      state.towMenuShow = false
      if (item.children) {
        state.towMenuShow = true
        state.towMenu = item.children
      }
    }
    const removeTowMenuShow = () => {
      state.towMenuShow = false
    }
    const resourceJump = (id) => {
      let path = '/about'
      let query = {}
      if (id === 'companyProfile') {
        query.id = 'companyProfile'
      } else if (id === 'serviceNetwork') {
        query.id = 'serviceNetwork'
      } else if (id === 'cooperationMode') {
        query.id = 'cooperationMode'
      }


      router.push({
        path: path,
        query: query
      })
    }

    onMounted(() => {
      getData()
    })
    return {
      state,
      linkTo,
      towMenuShow,
      removeTowMenuShow,
      resourceJump,
      linkToChild
    }
  }
})

</script>

<style scoped>
@media screen and (min-width: 800px) and (max-width: 900px) {
  .header-menu {
    margin-left: 0px !important;
  }
}

:global(.ant-dropdown-content .ant-dropdown-menu) {

  width: 100px;
  /* margin-top: 10px;
  padding-top: 10px; */
  padding: 0 !important;
}

:global(.ant-dropdown-content .ant-dropdown-menu .ant-dropdown-menu-item) {
  width: 100px;
  height: 40px;
  font-size: 16px;
}

:global(.ant-dropdown-content .ant-dropdown-menu .ant-dropdown-menu-item-active) {
  color: #fff;
  background: #2081EB;
}

.header-menu {
  margin-left: 50px;
  display: flex;
  justify-content: flex-start;
  height: 100%;
}

.header-navigation-item {
  font-family: 'PuHuiTiRegular';
  margin: 0px 16px;
  font-size: 16px;
  cursor: pointer;
  position: relative;
  margin-bottom: 12px;
  padding-top: 34px;
}

.header-navigation-item-dropdown {
  height: 25px;
  width: 32px;
  position: absolute;
  top: 0;
}

.header-navigation-item-towMenu {
  position: absolute;
  top: 80px;
  left: 0;
  width: 100%;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(5px);
  /* opacity: 0.9; */
  padding-bottom: 40px;
  animation: slideContentUp 0.3s linear both;
  overflow: hidden;
  box-shadow: 0px 1px 5px 0px rgba(185, 196, 218, 0.4);
  /* animation: slideContentDown 0.3s linear both; */
}

.towMenu-container {
  display: flex;
  margin-left: 225px;
}

.towMenu-oneMenu {
  width: 250px;
  font-size: 16px;
  font-weight: 400;
  color: #333333;
  line-height: 19px;
  margin: 30px 0;
}

.towMenu-towMenu {
  font-size: 14px;
  font-weight: 400;
  color: #6B7487;
  line-height: 16px;
  margin-bottom: 10px;
  cursor: pointer;
  width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 动态设置高度 */
@keyframes slideContentUp {
  from {
    height: 0;
  }

  to {
    height: 450px;
  }
}

.header-navigation-item:hover {
  font-weight: 700;
  color: #2081EB;
}

.header-navigation-item-active {
  font-weight: 700;
  /* color: #2081EB; */
}

.header-navigation-item::after {
  position: absolute;
  bottom: -12px;
  left: 50%;
  width: 36px;
  height: 0px;
  transition: height 0.2s;
  border-radius: 2px;
  content: "";
  background: #2081EB;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
}

/* .header-navigation-item:hover:not(.header-navigation-item-active)::after, */
.header-navigation-item-active::after {
  height: 3px;
}

.towMenu-towMenu-item:hover {
  color: #2081EB;
}
</style>
